module.exports = __webpack_public_path__ + "img/thirdSpecialities.cc22c350.png";